import { render, staticRenderFns } from "./Automatizador.vue?vue&type=template&id=5f67a6f1"
import script from "./Automatizador.vue?vue&type=script&lang=js"
export * from "./Automatizador.vue?vue&type=script&lang=js"
import style0 from "./Automatizador.vue?vue&type=style&index=0&id=5f67a6f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports